export enum SaveType {
    Create,
    Update
}
